import { MainComponent, Steps } from '@/models/onboarding';

export function formatStepsToArray(steps: Steps) {
  const formatedSteps = Object.entries(steps).reduce<MainComponent[]>(
    (acc, curr) => {
      const [stepKey, stepData] = curr;

      const components = stepData.components.map(component => ({
        ...component,
        parent: parseInt(stepKey)
      }));

      return [...acc, ...components];
    },
    []
  );

  return formatedSteps;
}
